var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-5 px-7 relative"},[_c('div',{staticClass:"text-lg text-gray-700 pb-3 border-b border-gray-500"},[_vm._v("用户协议")]),_c('div',{staticClass:"iframeBox"},[_c('iframe',{ref:"iframe",attrs:{"id":"iframe","src":"https://game.7li.cn/static/sdk/user.html","scrolling":"no","frameborder":"0","width":"100%","height":"4800"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }